import { render, staticRenderFns } from "./LocalUnitEditCensus.vue?vue&type=template&id=0a4dd6f8&scoped=true"
import script from "./LocalUnitEditCensus.vue?vue&type=script&lang=ts"
export * from "./LocalUnitEditCensus.vue?vue&type=script&lang=ts"
import style0 from "./LocalUnitEditCensus.vue?vue&type=style&index=0&id=0a4dd6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4dd6f8",
  null
  
)

export default component.exports